import React from 'react';
import NotFoundImg from '../../assets/images/not-found/not-found.png'
import Button from '../../components/shared/button';

import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function NotFound() {

  const { t: trans } = useTranslation();

  return (
    <div className="page-wrapper">
      <div className="not-found-page">
        <section>
          <h1>{trans('not-found.heading')}</h1>
          <Link to="/">
            <Button text={trans('not-found.go-back-btn')} variant="primary" />
          </Link>

        </section>
        <figure>
          <img src={NotFoundImg} className="not-found-image" alt="not-found" />
        </figure>
      </div>
    </div>
  );
}

export default NotFound;